import React from 'react';

import { withEventCatcher } from '@repo/event-processor';
import cn from 'classnames';

import { utilityCSSVariables } from '../../../css/utils';

import { BaseButton } from './BaseButton';
import styles from './Button.module.css';
import type { CircleButtonProps } from './types';

const getIconSize = (size: CircleButtonProps['size']) => {
  switch (size) {
    case 'm':
      return 20;
    case 's':
      return 14;
    case 'xs':
    case 'xxs':
    default:
      return 12;
  }
};

export const _CircleButton = React.forwardRef<
  HTMLButtonElement,
  CircleButtonProps
>(
  (
    {
      icon: Icon,
      ariaLabel,
      variant = 'secondary',
      size = 's',
      className,
      ...rest
    }: CircleButtonProps,
    ref
  ) => {
    const iconSize = getIconSize(size);

    return (
      <BaseButton
        {...rest}
        ref={ref}
        aria-label={ariaLabel}
        className={cn(
          className,
          styles[`variant-${variant}`],
          styles[`size-${size}`],
          styles['is-circle']
        )}
      >
        {Icon && (
          <span aria-hidden="true">
            <Icon
              activeColor="currentColor"
              color="currentColor"
              size={iconSize}
              transitionDuration={utilityCSSVariables.transition}
            />
          </span>
        )}
      </BaseButton>
    );
  }
);

_CircleButton.displayName = 'CircleButton';

export const CircleButton = withEventCatcher(_CircleButton);
